import React, { ReactNode } from 'react';

interface ModalProps {
    isOpen: boolean;
    onClose: () => void;
    children: ReactNode;
    className?: string;
}
const Modal: React.FC<ModalProps> = ({ isOpen, onClose, children, className }) => {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-[1000] flex items-center justify-center bg-black/50 h-screen w-full p-2 sm:p-4 overflow-hidden">
            <div
                className={`relative flex flex-col items-center
              bg-primary-light
              px-3 sm:px-6 md:px-8 lg:px-[56px] pt-3 sm:pt-4 md:pt-5 pb-4 sm:pb-5 md:pb-6
              rounded-[12px]
              shadow-[0_7px_9px_0_rgba(141,141,141,0.10),0_4px_13px_0_rgba(141,141,141,0.08)]
              w-full max-w-[98vw] sm:max-w-[90vw] md:max-w-[675px]
              max-h-[98vh] sm:max-h-[95vh]
              overflow-y-auto overflow-x-hidden
              z-[100] ${className}`}
            >
                <button
                    className="sticky flex
                  top-4 right-4 sm:top-6 sm:right-8 md:top-[24px] md:right-[56px]
                  ml-auto mb-2
                  w-[32px] h-[32px]
                  bg-white
                  rounded-[16px]
                  m-0 p-0
                  hover:bg-gray-100
                  transition-colors
                  z-10"
                    onClick={onClose}
                >
                    {' '}
                    <span className="w-96 text-3xl super-heavy -mt-0.5">&times;</span>
                </button>
                {children}
            </div>
        </div>
    );
};

export default Modal;
